import { ContentCell } from '../data-grid/components/content-cell';
import { DEFAULT_TEXT_LIST_MORE_TEXT } from '../data-grid/data-grid.constants';
import { DateRangeTooltip } from './date-range-tooltip';
import type { DataGridDateRangeview } from './date-range-view-types';
import { getFormattedDateRangeFunction } from './date-range-view-utils';

export function DateRangeView({
	startDate,
	endDate,
	details,
	timezone,
	parsed,
	dateRangeOptions,
	locale = 'en-US',
	dateStyle,
	timeStyle,
	dayStyle,
}: DataGridDateRangeview) {
	//todo: extract to a utils file https://bond-sports.atlassian.net/browse/BOND-13764
	const startDateArray = Array.isArray(startDate) ? startDate : [startDate];
	const endDateArray = Array.isArray(endDate) ? endDate : [endDate];
	const detailsArray = Array.isArray(details?.[0]) ? (details as string[][]) : [details as string[]];

	const formattedDateRangeFunction = getFormattedDateRangeFunction({
		timezone,
		locale,
		dateStyle,
		timeStyle,
		dayStyle,
	});
	//todo: extract to a utils file https://bond-sports.atlassian.net/browse/BOND-13764
	const formattedRanges = startDateArray.map((startDate, index) => {
		const endDate = endDateArray[index];
		const details = detailsArray?.[index];

		return formattedDateRangeFunction(startDate, endDate, details, dateRangeOptions);
	});

	const [firstRange, ...restRanges] = formattedRanges;
	const secondaryContent = [firstRange?.formattedTimeRange, ...(firstRange?.formattedExtraDetails ?? [])];

	const moreContent = restRanges?.length ? DEFAULT_TEXT_LIST_MORE_TEXT(restRanges?.length) : '';

	return (
		<ContentCell
			primaryContent={parsed?.primaryContent || firstRange?.formattedDateRange}
			primaryContentHover={parsed?.primaryContentHover}
			secondaryContent={parsed?.secondaryContent || secondaryContent}
			moreContentHover={parsed?.moreContentHover || <DateRangeTooltip restRanges={restRanges} />}
			moreContent={parsed?.moreContent || moreContent}
			moreContentLink={parsed?.moreContentLink}
			icon={parsed?.icon}
			iconOptions={parsed?.iconOptions}
		/>
	);
}
